import { useEffect, useState } from 'react';
import { ArrowUpIcon } from './Icons';

const VISIBLE_AFTER_VIEWPORTS = 1.5;
const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let frame = 0;
    const update = () => setVisible(window.scrollY > window.innerHeight * VISIBLE_AFTER_VIEWPORTS);
    const handleScroll = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  const handleClick = () => {
    const reducedMotion = window.matchMedia?.(REDUCED_MOTION_QUERY).matches ?? false;
    window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    document.querySelector<HTMLElement>('main')?.focus({ preventScroll: true });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Voltar ao topo"
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
      className={`fixed right-4 sm:right-5 bottom-floating z-sticky-cta w-11 h-11 rounded-full bg-white/95 hover:bg-white text-chocolate-dark border border-champagne-dark shadow-md flex items-center justify-center transition-[opacity,transform] duration-200 motion-reduce:transition-none focus:outline-none focus-visible:ring-2 focus-visible:ring-chocolate ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'
      }`}
    >
      <ArrowUpIcon />
    </button>
  );
}
